// extracted by mini-css-extract-plugin
export default {"header":"header_header__FHXlE","logo":"header_logo__5YUK-","nav":"header_nav__z1XeE","searchBar":"header_searchBar__n6FRg","noComponentFound":"header_noComponentFound__LrcRP"};